import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextIndentMore"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.0002 4.5H22.5002V6H15.0002V4.5ZM15.0002 9H20.2502V10.5H15.0002V9ZM15.0002 13.5H22.5002V15H15.0002V13.5ZM15.0002 18H20.2502V19.5H15.0002V18ZM10.5002 3H12.0002V21H10.5002V3ZM2.88758 16.875L1.83008 15.84L6.54758 11.25L1.83008 6.66L2.88758 5.625L8.67008 11.25L2.88758 16.875Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextIndentMore.vue"]]);
